<template>
  <div class="card">
    <div class="card-image">
      <figure class="image is-128x128">
        <img
          :src="data['avatar'] == null ? 'https://pics.dmm.co.jp/mono/actjpgs/nowprinting.gif' : data['avatar']"
          :alt="data['name']"
        >
      </figure>
    </div>
    <div class="card-content">
      <router-link :to="{path:'/filmBoard', query: {actor: data['name']}}">{{data['name']}}</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "ActorCard",
  props: {
    data: Object
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped>
.card .card-content {
  text-align: center;
}
.card .card-image .image {
  margin: auto;
  position: relative;
}
.card .card-content a {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.card .card-content span {
  margin-right: 0.5rem;
  color: #d64f4f;
}
</style>
